import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";

import Table from "../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    faAngleDown,
    faAngleUp,
    faAt,
    faEdit,
    faPhone,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    DeletarContatoController,
    ListarContatosComTelefoneController,
} from "../../../Controllers/Geral/Contatos/ContatosController";
import { IContatoComTelefone } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";

import Swal from "sweetalert2";
import { EfetuarDiscagemController } from "../../../Controllers/Geral/Telefonia/TelefoniaController";
import { useAtedimento } from "../../../Context/Atendimento";

import ModalComponent from "../../Modais";
import CadastrarContatoTelefone from "./CadastrarContatoTelefoneModal";
import { IComponentModal } from "../../Modais/IModalComponent";
import CadastrarContaContato from "./CadastrarContaContato";
import { formatPhoneTelefonia } from "../../../Tools/FormatTools";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { useTransformToRef } from "../../../hooks/useTransformToRef";
import { ContatoTelefone } from "./ContatoTelefone";
import Expandir from "../../Utils/Expandir";
import { IContatoTelefone } from "../../../Interfaces/Geral/Contatos/ContatoTelefone/ContatoTelefoneInterface";
import EditarContato from "./EditarContato";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";

interface ContatosProps {
    ID_CHAVE_ERP?: string;
    idConta?: number;
    idCaso?: number;
}

export default function ContatosCliente(props: ContatosProps) {
    const [lstContatos, setLstContatos] = useState<Array<IContatoComTelefone>>(
        []
    );
    const [loading, setLoading] = useState<"UAU" | "CAPYS" | false>(false);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [numeroEmAtendimento, setNumeroEmAtendimento] = useState("");

    const { bloquearInteracoes } = useAtendimentoPage();

    const Atendimento = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const lastAutoCall = useRef({
        TELEFONE: "",
    });

    const { modoAtendimento, FL_Ura_Telefonia } = useAtedimento();

    const updateContatosRef = useTransformToRef(updateContatos);
    useEffect(() => {
        if (props.idConta) updateContatosRef.current(props.idConta);
    }, [props.idConta, updateContatosRef]);

    function updateContatos(idConta: number) {
        setLoading("CAPYS");
        ListarContatosComTelefoneController(idConta)
            .then((res) =>
                res.sort(
                    (a, b) =>
                        -a.CONTATOS_TELEFONE?.length +
                        b.CONTATOS_TELEFONE?.length
                )
            )
            .then(async (res) => {
                setLstContatos(res);
                if (res.length && res[0].CONTATOS_TELEFONE.length) {
                    if (
                        res[0] &&
                        res[0].CONTATOS_TELEFONE[0].COD_DDD &&
                        props.idCaso &&
                        modoAtendimento === "FILA" &&
                        res[0].CONTATOS_TELEFONE[0].COD_DDD +
                            res[0].CONTATOS_TELEFONE[0].NR_TELEFONE !==
                            lastAutoCall.current?.TELEFONE &&
                        FL_Ura_Telefonia
                    ) {
                        const numeroEmAtendimento = `${res[0].CONTATOS_TELEFONE[0].COD_DDD}${res[0].CONTATOS_TELEFONE[0].NR_TELEFONE}`;
                        lastAutoCall.current.TELEFONE =
                            res[0].CONTATOS_TELEFONE[0].COD_DDD +
                            res[0].CONTATOS_TELEFONE[0].NR_TELEFONE;
                        setNumeroEmAtendimento(numeroEmAtendimento);
                        EfetuarDiscagemController(
                            formatPhoneTelefonia(
                                res[0].CONTATOS_TELEFONE[0].COD_DDD,
                                res[0].CONTATOS_TELEFONE[0].NR_TELEFONE ?? ""
                            ),
                            props.idCaso
                        );
                    }
                }
            })
            .finally(() => setLoading(false));
    }

    const columnsContato: Array<ColumnDescription> = [
        {
            dataField: "ID_CONTATO",
            text: "",
            formatter: (_cell, row, _index, extraData: string) => (
                <RowFormatterContato
                    {...row}
                    numeroEmAtendimento={extraData}
                    bloquearInteracoes={bloquearInteracoes}
                    idConta={props.idConta}
                    idCaso={props.idCaso}
                    setModal={setModal}
                    setShow={setShow}
                    setNumeroEmAtendimento={setNumeroEmAtendimento}
                    updateContatos={updateContatos}
                />
            ),
            formatExtraData: numeroEmAtendimento,
            headerClasses: "font-size-h3 font-weight-bold",
            isDummyField: true,
        },
    ];

    return (
        <>
            <div className="card card-custom card-stretch w-auto">
                <h3 className="d-flex justify-content-between align-items-center font-weight-bolder p-5 m-0">
                    Contatos
                    {!bloquearInteracoes && (
                        <button
                            className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap"
                            disabled={Atendimento?.FL_CASO_PARALIZADO}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () => (
                                        <CadastrarContaContato
                                            setShow={setShow}
                                            update={() =>
                                                updateContatos(
                                                    props.idConta ?? 0
                                                )
                                            }
                                            idConta={props.idConta ?? 0}
                                        />
                                    ),
                                    headerComponent: "Cadastrar Contato",
                                    IconHeader: faPhone,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />
                            Novo
                        </button>
                    )}
                </h3>

                {lstContatos.length > 0 ? (
                    <Table
                        columns={columnsContato}
                        data={lstContatos}
                        keyField={"ID_CONTATO"}
                        noDataIndication={
                            <div className="text-muted mb-5">
                                Nenhum contato encontrado
                            </div>
                        }
                        noSearch
                        bordered={false}
                        //expandRow={expandRow}
                        sizePerPage={2}
                        loading={loading === "CAPYS"}
                    />
                ) : (
                    <div className="text-center text-muted pb-5">
                        Nenhum contato cadastrado para esse cliente
                    </div>
                )}

                <ModalComponent
                    setShow={setShow}
                    show={show}
                    ModalComponent={modal}
                />
            </div>
        </>
    );
}

function RowFormatterContato(
    props: IContatoComTelefone & {
        numeroEmAtendimento: string;
        bloquearInteracoes: boolean;
        setShow: (show: boolean) => void;
        setModal: (modal: IComponentModal) => void;
        idConta: number;
        idCaso?: number;
        updateContatos: (idContato: number) => void;
        setNumeroEmAtendimento: Dispatch<SetStateAction<string>>;
        Atendimento: IAtendimentoExtraDetalhado | undefined;
    }
) {
    const [exibicacaoIcone, setExibicacaoIcone] = useState(false);

    const {
        numeroEmAtendimento,
        bloquearInteracoes,
        setShow,
        setModal,
        idConta,
        idCaso,
        updateContatos,
        setNumeroEmAtendimento,
        Atendimento,
        ...row
    } = props;

    const demaisContatosTelefone = Array.from(row.CONTATOS_TELEFONE);
    const contatoTelefone = demaisContatosTelefone.shift();
    const showButtonPrimeiroTelefone =
        numeroEmAtendimento ===
        `${contatoTelefone?.COD_DDD}${contatoTelefone?.NR_TELEFONE}`
            ? "DESLIGAR"
            : !numeroEmAtendimento
            ? "DISCAR"
            : "";

    return (
        <div className="w-auto ml-auto py-2 px-6">
            <div className="card-body p-0">
                <div className="w-100 d-flex flex-wrap flex-wrap-reverse g-2 justify-content-between">
                    <h3 className="font-weight-bolder font-size-h4 text-dark-75 mb-0">
                        {row.DS_NOME}
                    </h3>
                    <div className="d-flex flex-grow-1 flex-wrap align-itens-center justify-content-end g-2">
                        {!bloquearInteracoes && (
                            <>
                                <button
                                    className="btn btn-outline-success btn-xs d-flex align-items-center justify-content-center flex-nowrap"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () => (
                                                <CadastrarContatoTelefone
                                                    setShow={setShow}
                                                    update={() =>
                                                        updateContatos(
                                                            props.idConta ?? 0
                                                        )
                                                    }
                                                    idContato={row.ID_CONTATO}
                                                />
                                            ),
                                            headerComponent:
                                                "Cadastrar Telefone do Contato",
                                            IconHeader: faPhone,
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPlus}
                                        size="lg"
                                        className="mr-2"
                                    />{" "}
                                    Novo
                                </button>
                                <button
                                    className="btn btn-outline-info btn-xs d-flex align-items-center justify-content-center flex-nowrap"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () => (
                                                <EditarContato
                                                    row={row}
                                                    setShow={setShow}
                                                    update={() =>
                                                        updateContatos(
                                                            props.idConta ?? 0
                                                        )
                                                    }
                                                    idContato={row.ID_CONTATO}
                                                />
                                            ),
                                            headerComponent: "Editar Contato",
                                            IconHeader: faEdit,
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        size="lg"
                                        className="mr-2"
                                    />{" "}
                                    Editar
                                </button>
                                <button
                                    className="btn btn-outline-danger btn-xs d-flex align-items-center justify-content-center flex-nowrap"
                                    disabled={Atendimento?.FL_CASO_PARALIZADO}
                                    onClick={() => {
                                        Swal.fire({
                                            title: "Deseja apagar este contato?",
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                DeletarContatoController(
                                                    row.ID_CONTATO,
                                                    props.idConta
                                                ).then((response) => {
                                                    updateContatos(
                                                        props.idConta ?? 0
                                                    );
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        size="lg"
                                        className="mr-2"
                                    />{" "}
                                    Excluir
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                    <button
                        className="btn btn-lg d-flex flex-nowrap collapse"
                        type="button"
                        data-toggle="collapse"
                        onClick={() => setExibicacaoIcone((prev) => !prev)}
                        data-target={`#collapseContatos${row.ID_CONTATO}`}
                        aria-expanded="false"
                        aria-controls="collapseContatos"
                    >
                        <FontAwesomeIcon
                            icon={exibicacaoIcone ? faAngleUp : faAngleDown}
                            className="far m-1"
                        />
                    </button>
                </div>
                <div
                    id={`collapseContatos${row.ID_CONTATO}`}
                    className="collapse"
                >
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mt-1">
                        <div className="d-flex flex-wrap align-itens-center collapse">
                            {row.NR_CPF && (
                                <span className="label font-size-normal font-weight-bolder label-light-info label-inline mr-2 my-1 h-auto">
                                    CPF {row.NR_CPF}
                                </span>
                            )}

                            {row.DS_EMAIL &&
                                row.DS_EMAIL.split(";").map((res) => {
                                    return (
                                        <span
                                            className="label font-size-normal font-weight-bolder label-light-info label-inline mr-2 my-1 text-break "
                                            key={res}
                                        >
                                            <FontAwesomeIcon
                                                className="mr-2"
                                                icon={faAt}
                                            />{" "}
                                            {res}
                                        </span>
                                    );
                                })}
                        </div>
                        <div className="flex-grow-1 text-right">
                            <span className="label label-light-primary label-inline flex-grow-1 text-right">
                                {row.DS_TIPO_RELACAO_CLIENTE}
                            </span>
                        </div>
                    </div>

                    <div className="justify-content-between mr-1 mt-n2">
                        <div className="d-flex align-items-center justify-content-center g-2 font-weight-bold my-2">
                            <FontAwesomeIcon
                                icon={faPhone}
                                className="text-primary"
                            />
                            Telefones
                        </div>
                        {row.CONTATOS_TELEFONE?.length ? (
                            <div>
                                <ContatoTelefone
                                    contato_tel={
                                        contatoTelefone as IContatoTelefone
                                    }
                                    idCaso={props.idCaso}
                                    setNumeroEmAtendimento={
                                        setNumeroEmAtendimento
                                    }
                                    showDiscagemButton={
                                        showButtonPrimeiroTelefone
                                    }
                                    updateContatos={() => {
                                        if (props.idConta)
                                            updateContatos(props.idConta);
                                    }}
                                />
                                {demaisContatosTelefone.length > 0 && (
                                    <Expandir hideHR position="top">
                                        {demaisContatosTelefone.map(
                                            (contato_tel) => {
                                                const showButton =
                                                    numeroEmAtendimento ===
                                                    `${
                                                        contato_tel.COD_DDD
                                                            ? contato_tel.COD_DDD
                                                            : ""
                                                    }${contato_tel.NR_TELEFONE}`
                                                        ? "DESLIGAR"
                                                        : !numeroEmAtendimento
                                                        ? "DISCAR"
                                                        : "";
                                                return (
                                                    <ContatoTelefone
                                                        key={`${contato_tel.COD_DDD}${contato_tel.NR_TELEFONE}`}
                                                        contato_tel={
                                                            contato_tel
                                                        }
                                                        idCaso={props.idCaso}
                                                        setNumeroEmAtendimento={
                                                            setNumeroEmAtendimento
                                                        }
                                                        showDiscagemButton={
                                                            showButton
                                                        }
                                                        updateContatos={() => {
                                                            if (props.idConta)
                                                                updateContatos(
                                                                    props.idConta
                                                                );
                                                        }}
                                                    />
                                                );
                                            }
                                        )}
                                    </Expandir>
                                )}
                            </div>
                        ) : (
                            <div className="text-center text-muted">
                                Nenhum telefone cadastrado
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
